import PropTypes from 'prop-types';

export const CustomItemLivestreamSiteViewerDefault = (params, paramsLang, isLang) => ({
    screen_name: [],
    field_name: [
        {
            name: isLang ? '申込チェック（和文）' : '申込チェック',
            value: params?.field_name?.application_check,
            key: 'application_check',
            lang: false,
            isShow: true,
        },
        {
            name: '申込チェック（英文）',
            value: paramsLang?.field_name?.application_check,
            key: 'application_check',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '配信時間（和文）' : '配信時間',
            value: params?.field_name?.delivery_time,
            key: 'delivery_time',
            lang: false,
            isShow: true,
        },
        {
            name: '配信時間（英文）',
            value: paramsLang?.field_name?.delivery_time,
            key: 'delivery_time',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'タイトル（和文）' : 'タイトル',
            value: params?.field_name?.title,
            key: 'title',
            lang: false,
            isShow: true,
        },
        {
            name: 'タイトル（英文）',
            value: paramsLang?.field_name?.title,
            key: 'title',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '配信内容（和文）' : '配信内容',
            value: params?.field_name?.contents,
            key: 'contents',
            lang: false,
            isShow: true,
        },
        {
            name: '配信内容（英文）',
            value: paramsLang?.field_name?.contents,
            key: 'contents',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '出演者プロフィール（和文）' : '出演者プロフィール',
            value: params?.field_name?.performer_profile,
            key: 'performer_profile',
            lang: false,
            isShow: true,
        },
        {
            name: '出演者プロフィール（英文）',
            value: paramsLang?.field_name?.performer_profile,
            key: 'performer_profile',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '出演者（和文）' : '出演者',
            value: params?.field_name?.performer,
            key: 'performer',
            lang: false,
            isShow: true,
        },
        {
            name: '出演者（英文）',
            value: paramsLang?.field_name?.performer,
            key: 'performer',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '状況（和文）' : '状況',
            value: params?.field_name?.situation,
            key: 'situation',
            lang: false,
            isShow: true,
        },
        {
            name: '状況（英文）',
            value: paramsLang?.field_name?.situation,
            key: 'situation',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '料金（和文）' : '料金',
            value: params?.field_name?.fee,
            key: 'fee',
            lang: false,
            isShow: true,
        },
        {
            name: '料金（英文）',
            value: paramsLang?.field_name?.fee,
            key: 'fee',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '支払い状況（和文）' : '支払い状況',
            value: params?.field_name?.payment_status,
            key: 'payment_status',
            lang: false,
            isShow: true,
        },
        {
            name: '支払い状況（英文）',
            value: paramsLang?.field_name?.payment_status,
            key: 'payment_status',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '承認状況（和文）' : '承認状況',
            value: params?.field_name?.approval_status,
            key: 'approval_status',
            lang: false,
            isShow: true,
        },
        {
            name: '承認状況（英文）',
            value: paramsLang?.field_name?.approval_status,
            key: 'approval_status',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '視聴（和文）' : '視聴',
            value: params?.field_name?.watch,
            key: 'watch',
            lang: false,
            isShow: true,
        },
        {
            name: '視聴（英文）',
            value: paramsLang?.field_name?.watch,
            key: 'watch',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '日程（和文）' : '日程',
            value: params?.field_name?.date_livestream,
            key: 'date_livestream',
            lang: false,
            isShow: true,
        },
        {
            name: '日程（英文）',
            value: paramsLang?.field_name?.date_livestream,
            key: 'date_livestream',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'ライブ配信を見る（和文）' : 'ライブ配信を見る',
            value: params?.field_name?.watch_livestream_free,
            key: 'watch_livestream_free',
            lang: false,
            isShow: true,
        },
        {
            name: 'ライブ配信を見る（英文）',
            value: paramsLang?.field_name?.watch_livestream_free,
            key: 'watch_livestream_free',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '時間帯（和文）' : '時間帯',
            value: params?.field_name?.time_zone,
            key: 'time_zone',
            lang: false,
            isShow: true,
        },
        {
            name: '時間帯（英文）',
            value: paramsLang?.field_name?.time_zone,
            key: 'time_zone',
            lang: true,
            isShow: isLang,
        },
    ],
    button_name: [
        {
            name: isLang ? 'ライブ配信視聴申込（和文）' : 'ライブ配信視聴申込',
            value: params?.button_name?.livestream_viewing_application,
            key: 'livestream_viewing_application',
            lang: false,
            isShow: true,
        },
        {
            name: 'ライブ配信視聴申込（英文）',
            value: paramsLang?.button_name?.livestream_viewing_application,
            key: 'livestream_viewing_application',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '申し込む（和文）' : '申し込む',
            value: params?.button_name?.apply,
            key: 'apply',
            lang: false,
            isShow: true,
        },
        {
            name: '申し込む（英文）',
            value: paramsLang?.button_name?.apply,
            key: 'apply',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'ライブ配信を見る（和文）' : 'ライブ配信を見る',
            value: params?.button_name?.watch_livestream,
            key: 'watch_livestream',
            lang: false,
            isShow: true,
        },
        {
            name: 'ライブ配信を見る（英文）',
            value: paramsLang?.button_name?.watch_livestream,
            key: 'watch_livestream',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '資料請求（和文）' : '資料請求',
            value: params?.button_name?.document_link,
            key: 'document_link',
            lang: false,
            isShow: true,
        },
        {
            name: '資料請求（英文）',
            value: paramsLang?.button_name?.document_link,
            key: 'document_link',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '資料ダウンロード（和文）' : '資料ダウンロード',
            value: params?.button_name?.document,
            key: 'document',
            lang: false,
            isShow: true,
        },
        {
            name: '資料ダウンロード（英文）',
            value: paramsLang?.button_name?.document,
            key: 'document',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'お問合せ（和文）' : 'お問合せ',
            value: params?.button_name?.inquiry,
            key: 'inquiry',
            lang: false,
            isShow: true,
        },
        {
            name: 'お問合せ（英文）',
            value: paramsLang?.button_name?.inquiry,
            key: 'inquiry',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'アンケート（和文）' : 'アンケート',
            value: params?.button_name?.survey_link,
            key: 'survey_link',
            lang: false,
            isShow: true,
        },
        {
            name: 'アンケート（英文）',
            value: paramsLang?.button_name?.survey_link,
            key: 'survey_link',
            lang: true,
            isShow: isLang,
        },
    ],
});

CustomItemLivestreamSiteViewerDefault.defaultProps = {
    params: {},
    paramsLang: {},
    isLang: false,
};

CustomItemLivestreamSiteViewerDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
    paramsLang: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLang: PropTypes.bool,
};

export const CustomItemSeminarSiteViewerDefault = (params, paramsLang, isLang) => ({
    screen_name: [
        {
            name: isLang ? 'セミナー詳細（和文）' : 'セミナー詳細',
            value: params?.screen_name?.seminar_details,
            key: 'seminar_details',
            lang: false,
            isShow: true,
        },
        {
            name: 'セミナー詳細（英文）',
            value: paramsLang?.screen_name?.seminar_details,
            key: 'seminar_details',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '受講済みのセミナー詳細（和文）' : '受講済みのセミナー詳細',
            value: params?.screen_name?.seminar_registered_details,
            key: 'seminar_registered_details',
            lang: false,
            isShow: true,
        },
        {
            name: '受講済みのセミナー詳細（英文）',
            value: paramsLang?.screen_name?.seminar_registered_details,
            key: 'seminar_registered_details',
            lang: true,
            isShow: isLang,
        },
    ],
    field_name: [
        {
            name: isLang ? '申込チェック（和文）' : '申込チェック',
            value: params?.field_name?.application_check,
            key: 'application_check',
            lang: false,
            isShow: true,
        },
        {
            name: '申込チェック（英文）',
            value: paramsLang?.field_name?.application_check,
            key: 'application_check',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '時間（和文）' : '時間',
            value: params?.field_name?.time,
            key: 'time',
            lang: false,
            isShow: true,
        },
        {
            name: '時間（英文）',
            value: paramsLang?.field_name?.time,
            key: 'time',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '講演名（和文）' : '講演名',
            value: params?.field_name?.lecture_name,
            key: 'lecture_name',
            lang: false,
            isShow: true,
        },
        {
            name: '講演名（英文）',
            value: paramsLang?.field_name?.lecture_name,
            key: 'lecture_name',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '講演内容（和文）' : '講演内容',
            value: params?.field_name?.lecture_content,
            key: 'lecture_content',
            lang: false,
            isShow: true,
        },
        {
            name: '講演内容（英文）',
            value: paramsLang?.field_name?.lecture_content,
            key: 'lecture_content',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '講演者（和文）' : '講演者',
            value: params?.field_name?.speaker,
            key: 'speaker',
            lang: false,
            isShow: true,
        },
        {
            name: '講演者（英文）',
            value: paramsLang?.field_name?.speaker,
            key: 'speaker',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '状況（和文）' : '状況',
            value: params?.field_name?.situation,
            key: 'situation',
            lang: false,
            isShow: true,
        },
        {
            name: '状況（英文）',
            value: paramsLang?.field_name?.situation,
            key: 'situation',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '料金（和文）' : '料金',
            value: params?.field_name?.price,
            key: 'price',
            lang: false,
            isShow: true,
        },
        {
            name: '料金（英文）',
            value: paramsLang?.field_name?.price,
            key: 'price',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '再生時間（和文）' : '再生時間',
            value: params?.field_name?.playback_time,
            key: 'playback_time',
            lang: false,
            isShow: true,
        },
        {
            name: '再生時間（英文）',
            value: paramsLang?.field_name?.playback_time,
            key: 'playback_time',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '支払い状況（和文）' : '支払い状況',
            value: params?.field_name?.payment_status,
            key: 'payment_status',
            lang: false,
            isShow: true,
        },
        {
            name: '支払い状況（英文）',
            value: paramsLang?.field_name?.payment_status,
            key: 'payment_status',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '承認状況（和文）' : '承認状況',
            value: params?.field_name?.approval_status,
            key: 'approval_status',
            lang: false,
            isShow: true,
        },
        {
            name: '承認状況（英文）',
            value: paramsLang?.field_name?.approval_status,
            key: 'approval_status',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '受講（和文）' : '受講',
            value: params?.field_name?.attendance,
            key: 'attendance',
            lang: false,
            isShow: true,
        },
        {
            name: '受講（英文）',
            value: paramsLang?.field_name?.attendance,
            key: 'attendance',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '期間（和文）' : '期間',
            value: params?.field_name?.seminar_time,
            key: 'seminar_time',
            lang: false,
            isShow: true,
        },
        {
            name: '期間（英文）',
            value: paramsLang?.field_name?.seminar_time,
            key: 'seminar_time',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '講演者写真（和文）' : '講演者写真',
            value: params?.field_name?.speaker_photo,
            key: 'speaker_photo',
            lang: false,
            isShow: true,
        },
        {
            name: '講演者写真（英文）',
            value: paramsLang?.field_name?.speaker_photo,
            key: 'speaker_photo',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '講演者プロフィール（和文）' : '講演者プロフィール',
            value: params?.field_name?.speaker_profile,
            key: 'speaker_profile',
            lang: false,
            isShow: true,
        },
        {
            name: '講演者プロフィール（英文）',
            value: paramsLang?.field_name?.speaker_profile,
            key: 'speaker_profile',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '申込最大人数（和文）' : '申込最大人数',
            value: params?.field_name?.maximum_applicants,
            key: 'maximum_applicants',
            lang: false,
            isShow: true,
        },
        {
            name: '申込最大人数（英文）',
            value: paramsLang?.field_name?.maximum_applicants,
            key: 'maximum_applicants',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '受講費用（和文）' : '受講費用',
            value: params?.field_name?.course_fee,
            key: 'course_fee',
            lang: false,
            isShow: true,
        },
        {
            name: '受講費用（英文）',
            value: paramsLang?.field_name?.course_fee,
            key: 'course_fee',
            lang: true,
            isShow: isLang,
        },
    ],
    button_name: [
        {
            name: isLang ? 'セミナー受講申込（和文）' : 'セミナー受講申込',
            value: params?.button_name?.seminar_application,
            key: 'seminar_application',
            lang: false,
            isShow: true,
        },
        {
            name: 'セミナー受講申込（英文）',
            value: paramsLang?.button_name?.seminar_application,
            key: 'seminar_application',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '申し込む（和文）' : '申し込む',
            value: params?.button_name?.apply_seminar,
            key: 'apply_seminar',
            lang: false,
            isShow: true,
        },
        {
            name: '申し込む（英文）',
            value: paramsLang?.button_name?.apply_seminar,
            key: 'apply_seminar',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '検索（和文）' : '検索',
            value: params?.button_name?.search_seminar,
            key: 'search_seminar',
            lang: false,
            isShow: true,
        },
        {
            name: '検索（英文）',
            value: paramsLang?.button_name?.search_seminar,
            key: 'search_seminar',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '資料請求（和文）' : '資料請求',
            value: params?.button_name?.document_link,
            key: 'document_link',
            lang: false,
            isShow: true,
        },
        {
            name: '資料請求（英文）',
            value: paramsLang?.button_name?.document_link,
            key: 'document_link',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '資料ダウンロード（和文）' : '資料ダウンロード',
            value: params?.button_name?.document,
            key: 'document',
            lang: false,
            isShow: true,
        },
        {
            name: '資料ダウンロード（英文）',
            value: paramsLang?.button_name?.document,
            key: 'document',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'お問合せ（和文）' : 'お問合せ',
            value: params?.button_name?.link_contact,
            key: 'link_contact',
            lang: false,
            isShow: true,
        },
        {
            name: 'お問合せ（英文）',
            value: paramsLang?.button_name?.link_contact,
            key: 'link_contact',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'アンケート（和文）' : 'アンケート',
            value: params?.button_name?.survey_link,
            key: 'survey_link',
            lang: false,
            isShow: true,
        },
        {
            name: 'アンケート（英文）',
            value: paramsLang?.button_name?.survey_link,
            key: 'survey_link',
            lang: true,
            isShow: isLang,
        },
    ],
});

CustomItemSeminarSiteViewerDefault.defaultProps = {
    params: {},
    paramsLang: {},
    isLang: false,
};

CustomItemSeminarSiteViewerDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
    paramsLang: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLang: PropTypes.bool,
};

export const CustomItemExhibitionSiteViewerDefault = (params, paramsLang, isLang) => ({
    screen_name: [],
    field_name: [
        {
            name: isLang ? '閲覧企業チェック（和文）' : '閲覧企業チェック',
            value: params?.field_name?.browsing_company_check,
            key: 'browsing_company_check',
            lang: false,
            isShow: true,
        },
        {
            name: '閲覧企業チェック（英文）',
            value: paramsLang?.field_name?.browsing_company_check,
            key: 'browsing_company_check',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '出展参加者（和文）' : '出展参加者',
            value: params?.field_name?.exhibitor_participants,
            key: 'exhibitor_participants',
            lang: false,
            isShow: true,
        },
        {
            name: '出展参加者（英文）',
            value: paramsLang?.field_name?.exhibitor_participants,
            key: 'exhibitor_participants',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '業種（和文）' : '業種',
            value: params?.field_name?.industry,
            key: 'industry',
            lang: false,
            isShow: true,
        },
        {
            name: '業種（英文）',
            value: paramsLang?.field_name?.industry,
            key: 'industry',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '商品名（和文）' : '商品名',
            value: params?.field_name?.product_name,
            key: 'product_name',
            lang: false,
            isShow: true,
        },
        {
            name: '商品名（英文）',
            value: paramsLang?.field_name?.product_name,
            key: 'product_name',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '商品の画・動・音（和文）' : '商品の画・動・音',
            value: params?.field_name?.product_image_movement_sound,
            key: 'product_image_movement_sound',
            lang: false,
            isShow: true,
        },
        {
            name: '商品の画・動・音（英文）',
            value: paramsLang?.field_name?.product_image_movement_sound,
            key: 'product_image_movement_sound',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '注文番号（和文）' : '注文番号',
            value: params?.field_name?.order_number,
            key: 'order_number',
            lang: false,
            isShow: true,
        },
        {
            name: '注文番号（英文）',
            value: paramsLang?.field_name?.order_number,
            key: 'order_number',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '注文日（和文）' : '注文日',
            value: params?.field_name?.order_date,
            key: 'order_date',
            lang: false,
            isShow: true,
        },
        {
            name: '注文日（英文）',
            value: paramsLang?.field_name?.order_date,
            key: 'order_date',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'お支払方法（和文）' : 'お支払方法',
            value: params?.field_name?.payment_method,
            key: 'payment_method',
            lang: false,
            isShow: true,
        },
        {
            name: 'お支払方法（英文）',
            value: paramsLang?.field_name?.payment_method,
            key: 'payment_method',
            lang: true,
            isShow: isLang,
        },
        {},
        {
            name: isLang ? '支払い状況（和文）' : '支払い状況',
            value: params?.field_name?.payment_status,
            key: 'payment_status',
            lang: false,
            isShow: true,
        },
        {
            name: '支払い状況（英文）',
            value: paramsLang?.field_name?.payment_status,
            key: 'payment_status',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '注文内容（和文）' : '注文内容',
            value: params?.field_name?.order_details,
            key: 'order_details',
            lang: false,
            isShow: true,
        },
        {
            name: '注文内容（英文）',
            value: paramsLang?.field_name?.order_details,
            key: 'order_details',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'ゾーン（和文）' : 'ゾーン',
            value: params?.field_name?.zone,
            key: 'zone',
            lang: false,
            isShow: true,
        },
        {
            name: 'ゾーン（英文）',
            value: paramsLang?.field_name?.zone,
            key: 'zone',
            lang: true,
            isShow: isLang,
        },
    ],
    button_name: [
        {
            name: isLang ? '検索（和文）' : '検索',
            value: params?.button_name?.search,
            key: 'search',
            lang: false,
            isShow: true,
        },
        {
            name: '検索（英文）',
            value: paramsLang?.button_name?.search,
            key: 'search',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '見たい企業リストを表示（和文）' : '見たい企業リストを表示',
            value: params?.button_name?.lis_companies_want_see,
            key: 'lis_companies_want_see',
            lang: false,
            isShow: true,
        },
        {
            name: '見たい企業リストを表示（英文）',
            value: paramsLang?.button_name?.lis_companies_want_see,
            key: 'lis_companies_want_see',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'ダイレクト選択（和文）' : 'ダイレクト選択',
            value: params?.button_name?.direct_selection,
            key: 'direct_selection',
            lang: false,
            isShow: true,
        },
        {
            name: 'ダイレクト選択（英文）',
            value: paramsLang?.button_name?.direct_selection,
            key: 'direct_selection',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '前の企業（和文）' : '前の企業',
            value: params?.button_name?.previous_company,
            key: 'previous_company',
            lang: false,
            isShow: true,
        },
        {
            name: '前の企業（英文）',
            value: paramsLang?.button_name?.previous_company,
            key: 'previous_company',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '次の企業（和文）' : '次の企業',
            value: params?.button_name?.next_company,
            key: 'next_company',
            lang: false,
            isShow: true,
        },
        {
            name: '次の企業（英文）',
            value: paramsLang?.button_name?.next_company,
            key: 'next_company',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '出展企業詳細情報（和文）' : '出展企業詳細情報',
            value: params?.button_name?.exhibitors_detailed_info,
            key: 'exhibitors_detailed_info',
            lang: false,
            isShow: true,
        },
        {
            name: '出展企業詳細情報（英文）',
            value: paramsLang?.button_name?.exhibitors_detailed_info,
            key: 'exhibitors_detailed_info',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'カートに入れる（和文）' : 'カートに入れる',
            value: params?.button_name?.add_to_cart,
            key: 'add_to_cart',
            lang: false,
            isShow: true,
        },
        {
            name: 'カートに入れる（英文）',
            value: paramsLang?.button_name?.add_to_cart,
            key: 'add_to_cart',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '前の商品（和文）' : '前の商品',
            value: params?.button_name?.previous_product,
            key: 'previous_product',
            lang: false,
            isShow: true,
        },
        {
            name: '前の商品（英文）',
            value: paramsLang?.button_name?.previous_product,
            key: 'previous_product',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '次の商品（和文）' : '次の商品',
            value: params?.button_name?.next_product,
            key: 'next_product',
            lang: false,
            isShow: true,
        },
        {
            name: '次の商品（英文）',
            value: paramsLang?.button_name?.next_product,
            key: 'next_product',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '注文手続きへ（和文）' : '注文手続きへ',
            value: params?.button_name?.order_procedure,
            key: 'order_procedure',
            lang: false,
            isShow: true,
        },
        {
            name: '注文手続きへ（英文）',
            value: paramsLang?.button_name?.order_procedure,
            key: 'order_procedure',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '上記の内容で注文する（和文）' : '上記の内容で注文する',
            value: params?.button_name?.order_with_contents,
            key: 'order_with_contents',
            lang: false,
            isShow: true,
        },
        {
            name: '上記の内容で注文する（英文）',
            value: paramsLang?.button_name?.order_with_contents,
            key: 'order_with_contents',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '内訳を表示する（和文）' : '内訳を表示する',
            value: params?.button_name?.show_breakdown,
            key: 'show_breakdown',
            lang: false,
            isShow: true,
        },
        {
            name: '内訳を表示する（英文）',
            value: paramsLang?.button_name?.show_breakdown,
            key: 'show_breakdown',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '閉じる（和文）' : '閉じる',
            value: params?.button_name?.close_up,
            key: 'close_up',
            lang: false,
            isShow: true,
        },
        {
            name: '閉じる（英文）',
            value: paramsLang?.button_name?.close_up,
            key: 'close_up',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '商品購入（和文）' : '商品購入',
            value: params?.button_name?.purchase_products,
            key: 'purchase_products',
            lang: false,
            isShow: true,
        },
        {
            name: '商品購入（英文）',
            value: paramsLang?.button_name?.purchase_products,
            key: 'purchase_products',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '商談／お問合せ（和文）' : '商談／お問合せ',
            value: params?.button_name?.business_contact,
            key: 'business_contact',
            lang: false,
            isShow: true,
        },
        {
            name: '商談／お問合せ（英文）',
            value: paramsLang?.button_name?.business_contact,
            key: 'business_contact',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '担当者と直接相談（和文）' : '担当者と直接相談',
            value: params?.button_name?.direct_consultation,
            key: 'direct_consultation',
            lang: false,
            isShow: true,
        },
        {
            name: '担当者と直接相談（英文）',
            value: paramsLang?.button_name?.direct_consultation,
            key: 'direct_consultation',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '資料請求（和文）' : '資料請求',
            value: params?.button_name?.document_request,
            key: 'document_request',
            lang: false,
            isShow: true,
        },
        {
            name: '資料請求（英文）',
            value: paramsLang?.button_name?.document_request,
            key: 'document_request',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '資料ダウンロード（和文）' : '資料ダウンロード',
            value: params?.button_name?.download_materials,
            key: 'download_materials',
            lang: false,
            isShow: true,
        },
        {
            name: '資料ダウンロード（英文）',
            value: paramsLang?.button_name?.download_materials,
            key: 'download_materials',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'アンケート（和文）' : 'アンケート',
            value: params?.button_name?.questionnaire,
            key: 'questionnaire',
            lang: false,
            isShow: true,
        },
        {
            name: 'アンケート（英文）',
            value: paramsLang?.button_name?.questionnaire,
            key: 'questionnaire',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '掲示板サロン（和文）' : '掲示板サロン',
            value: params?.button_name?.board_salon,
            key: 'board_salon',
            lang: false,
            isShow: true,
        },
        {
            name: '掲示板サロン（英文）',
            value: paramsLang?.button_name?.board_salon,
            key: 'board_salon',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '外部リンク（和文）' : '外部リンク',
            value: params?.button_name?.external_link,
            key: 'external_link',
            lang: false,
            isShow: true,
        },
        {
            name: '外部リンク（英文）',
            value: paramsLang?.button_name?.external_link,
            key: 'external_link',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '名刺交換（和文）' : '名刺交換',
            value: params?.button_name?.business_card,
            key: 'business_card',
            lang: false,
            isShow: true,
        },
        {
            name: '名刺交換（英文）',
            value: paramsLang?.button_name?.business_card,
            key: 'business_card',
            lang: true,
            isShow: isLang,
        },
    ],
});

CustomItemExhibitionSiteViewerDefault.defaultProps = {
    params: {},
    paramsLang: {},
    isLang: false,
};

CustomItemExhibitionSiteViewerDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
    paramsLang: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLang: PropTypes.bool,
};

export const CustomItemSidebarSiteViewerDefault = (params, paramsLang, isLang) => ({
    screen_name: [
        {
            name: isLang ? '入場者ログイン（和文）' : '入場者ログイン',
            value: params?.screen_name?.visitor_login,
            key: 'visitor_login',
            lang: false,
            isShow: true,
        },
        {
            name: '入場者ログイン（英文）',
            value: paramsLang?.screen_name?.visitor_login,
            key: 'visitor_login',
            lang: true,
            isShow: isLang,
        },
    ],
    field_name: [
        {
            name: isLang ? '出展参加者情報一覧（和文）' : '出展参加者情報一覧',
            value: params?.field_name?.exhibitor_info_list,
            key: 'exhibitor_info_list',
            lang: false,
            isShow: true,
        },
        {
            name: '出展参加者情報一覧（英文）',
            value: paramsLang?.field_name?.exhibitor_info_list,
            key: 'exhibitor_info_list',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '見たい企業リスト（和文）' : '見たい企業リスト',
            value: params?.field_name?.list_companies_want_see,
            key: 'list_companies_want_see',
            lang: false,
            isShow: true,
        },
        {
            name: '見たい企業リスト（英文）',
            value: paramsLang?.field_name?.list_companies_want_see,
            key: 'list_companies_want_see',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'セミナー一覧（和文）' : 'セミナー一覧',
            value: params?.field_name?.seminar_list,
            key: 'seminar_list',
            lang: false,
            isShow: true,
        },
        {
            name: 'セミナー一覧（英文）',
            value: paramsLang?.field_name?.seminar_list,
            key: 'seminar_list',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '受講申込みリスト（和文）' : '受講申込みリスト',
            value: params?.field_name?.application_list,
            key: 'application_list',
            lang: false,
            isShow: true,
        },
        {
            name: '受講申込みリスト（英文）',
            value: paramsLang?.field_name?.application_list,
            key: 'application_list',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'ライブ配信（和文）' : 'ライブ配信',
            value: params?.field_name?.livestreaming,
            key: 'livestreaming',
            lang: false,
            isShow: true,
        },
        {
            name: 'ライブ配信（英文）',
            value: paramsLang?.field_name?.livestreaming,
            key: 'livestreaming',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'ライブ配信申込みリスト（和文）' : 'ライブ配信申込みリスト',
            value: params?.field_name?.livestream_application_list,
            key: 'livestream_application_list',
            lang: false,
            isShow: true,
        },
        {
            name: 'ライブ配信申込みリスト（英文）',
            value: paramsLang?.field_name?.livestream_application_list,
            key: 'livestream_application_list',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'カート（和文）' : 'カート',
            value: params?.field_name?.cart,
            key: 'cart',
            lang: false,
            isShow: true,
        },
        {
            name: 'カート（英文）',
            value: paramsLang?.field_name?.cart,
            key: 'cart',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'よくあるご質問（和文）' : 'よくあるご質問',
            value: params?.field_name?.faq,
            key: 'faq',
            lang: false,
            isShow: true,
        },
        {
            name: 'よくあるご質問（英文）',
            value: paramsLang?.field_name?.faq,
            key: 'faq',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'アンケート（和文）' : 'アンケート',
            value: params?.field_name?.survey,
            key: 'survey',
            lang: false,
            isShow: true,
        },
        {
            name: 'アンケート（英文）',
            value: paramsLang?.field_name?.survey,
            key: 'survey',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '出口（和文）' : '出口',
            value: params?.field_name?.logout,
            key: 'logout',
            lang: false,
            isShow: true,
        },
        {
            name: '出口（英文）',
            value: paramsLang?.field_name?.logout,
            key: 'logout',
            lang: true,
            isShow: isLang,
        },
    ],
    button_name: [],
});

CustomItemSidebarSiteViewerDefault.defaultProps = {
    params: {},
    paramsLang: {},
    isLang: false,
};

CustomItemSidebarSiteViewerDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
    paramsLang: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLang: PropTypes.bool,
};

export const CustomItemEventSiteViewerDefault = (params, paramsLang, isLang) => ({
    screen_name: [],
    field_name: [
        {
            name: isLang ? '開催期間（和文）' : '開催期間',
            value: params?.field_name?.holding_period,
            key: 'holding_period',
            lang: false,
            isShow: true,
        },
        {
            name: '開催期間（英文）',
            value: paramsLang?.field_name?.holding_period,
            key: 'holding_period',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '開催時間（和文）' : '開催時間',
            value: params?.field_name?.open_time,
            key: 'open_time',
            lang: false,
            isShow: true,
        },
        {
            name: '開催時間（英文）',
            value: paramsLang?.field_name?.open_time,
            key: 'open_time',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '開催場所（和文）' : '開催場所',
            value: params?.field_name?.venue,
            key: 'venue',
            lang: false,
            isShow: true,
        },
        {
            name: '開催場所（英文）',
            value: paramsLang?.field_name?.venue,
            key: 'venue',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '概要（和文）' : '概要',
            value: params?.field_name?.overview,
            key: 'overview',
            lang: false,
            isShow: true,
        },
        {
            name: '概要（英文）',
            value: paramsLang?.field_name?.overview,
            key: 'overview',
            lang: true,
            isShow: isLang,
        },
    ],
    button_name: [
        {
            name: isLang ? '送信する（和文）' : '送信する',
            value: params?.button_name?.send,
            key: 'send',
            lang: false,
            isShow: true,
        },
        {
            name: '送信する（英文）',
            value: paramsLang?.button_name?.send,
            key: 'send',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '出展募集要項（和文）' : '出展募集要項',
            value: params?.button_name?.exhibitor_guidelines,
            key: 'exhibitor_guidelines',
            lang: false,
            isShow: true,
        },
        {
            name: '出展募集要項（英文）',
            value: paramsLang?.button_name?.exhibitor_guidelines,
            key: 'exhibitor_guidelines',
            lang: true,
            isShow: isLang,
        },
    ],
});

CustomItemEventSiteViewerDefault.defaultProps = {
    params: {},
    paramsLang: {},
    isLang: false,
};

CustomItemEventSiteViewerDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
    paramsLang: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLang: PropTypes.bool,
};

export const CustomItemPersonInfoSiteViewerDefault = (params, paramsLang, isLang) => ({
    screen_name: [],
    field_name: [
        {
            name: isLang ? '部署（和文）' : '部署',
            value: params?.field_name?.department,
            key: 'department',
            lang: false,
            isShow: true,
        },
        {
            name: '部署（英文）',
            value: paramsLang?.field_name?.department,
            key: 'department',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '役職（和文）' : '役職',
            value: params?.field_name?.position,
            key: 'position',
            lang: false,
            isShow: true,
        },
        {
            name: '役職（英文）',
            value: paramsLang?.field_name?.position,
            key: 'position',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '氏名（和文）' : '氏名',
            value: params?.field_name?.name,
            key: 'name',
            lang: false,
            isShow: true,
        },
        {
            name: '氏名（英文）',
            value: paramsLang?.field_name?.name,
            key: 'name',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '郵便番号（和文）' : '郵便番号',
            value: params?.field_name?.zip_code,
            key: 'zip_code',
            lang: false,
            isShow: true,
        },
        {
            name: '郵便番号（英文）',
            value: paramsLang?.field_name?.zip_code,
            key: 'zip_code',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '住所（和文）' : '住所',
            value: params?.field_name?.address,
            key: 'address',
            lang: false,
            isShow: true,
        },
        {
            name: '住所（英文）',
            value: paramsLang?.field_name?.address,
            key: 'address',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '電話番号（和文）' : '電話番号',
            value: params?.field_name?.phone_number,
            key: 'phone_number',
            lang: false,
            isShow: true,
        },
        {
            name: '電話番号（英文）',
            value: paramsLang?.field_name?.phone_number,
            key: 'phone_number',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'FAX 番号（和文）' : 'FAX 番号',
            value: params?.field_name?.fax_number,
            key: 'fax_number',
            lang: false,
            isShow: true,
        },
        {
            name: 'FAX 番号（英文）',
            value: paramsLang?.field_name?.fax_number,
            key: 'fax_number',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '国・地域（和文）' : '国・地域',
            value: params?.field_name?.country_region,
            key: 'country_region',
            lang: false,
            isShow: true,
        },
        {
            name: '国・地域（英文）',
            value: paramsLang?.field_name?.country_region,
            key: 'country_region',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '名刺用メールアドレス（和文）' : '名刺用メールアドレス',
            value: params?.field_name?.business_card_email,
            key: 'business_card_email',
            lang: false,
            isShow: true,
        },
        {
            name: '名刺用メールアドレス（英文）',
            value: paramsLang?.field_name?.business_card_email,
            key: 'business_card_email',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '通知先メールアドレス（和文）' : '通知先メールアドレス',
            value: params?.field_name?.notification_email,
            key: 'notification_email',
            lang: false,
            isShow: true,
        },
        {
            name: '通知先メールアドレス（英文）',
            value: paramsLang?.field_name?.notification_email,
            key: 'notification_email',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '勤務先（和文）' : '勤務先',
            value: params?.field_name?.work_place,
            key: 'work_place',
            lang: false,
            isShow: true,
        },
        {
            name: '勤務先（英文）',
            value: paramsLang?.field_name?.work_place,
            key: 'work_place',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '業種（和文）' : '業種',
            value: params?.field_name?.industry_type,
            key: 'industry_type',
            lang: false,
            isShow: true,
        },
        {
            name: '業種（英文）',
            value: paramsLang?.field_name?.industry_type,
            key: 'industry_type',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '職種（和文）' : '職種',
            value: params?.field_name?.job_type,
            key: 'job_type',
            lang: false,
            isShow: true,
        },
        {
            name: '職種（英文）',
            value: paramsLang?.field_name?.job_type,
            key: 'job_type',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '従業員数（和文）' : '従業員数',
            value: params?.field_name?.number_employees,
            key: 'number_employees',
            lang: false,
            isShow: true,
        },
        {
            name: '従業員数（英文）',
            value: paramsLang?.field_name?.number_employees,
            key: 'number_employees',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '展示会入場申込み（和文）' : '展示会入場申込み',
            value: params?.field_name?.exhibition_application,
            key: 'exhibition_application',
            lang: false,
            isShow: true,
        },
        {
            name: '展示会入場申込み（英文）',
            value: paramsLang?.field_name?.exhibition_application,
            key: 'exhibition_application',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'セミナー受講申込（和文）' : 'セミナー受講申込',
            value: params?.field_name?.seminar_application,
            key: 'seminar_application',
            lang: false,
            isShow: true,
        },
        {
            name: 'セミナー受講申込（英文）',
            value: paramsLang?.field_name?.seminar_application,
            key: 'seminar_application',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'ライブ配信視聴申込み（和文）' : 'ライブ配信視聴申込み',
            value: params?.field_name?.livestream_application,
            key: 'livestream_application',
            lang: false,
            isShow: true,
        },
        {
            name: 'ライブ配信視聴申込み（英文）',
            value: paramsLang?.field_name?.livestream_application,
            key: 'livestream_application',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'メールアドレス（和文）' : 'メールアドレス',
            value: params?.field_name?.email,
            key: 'email',
            lang: false,
            isShow: true,
        },
        {
            name: 'メールアドレス（英文）',
            value: paramsLang?.field_name?.email,
            key: 'email',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '年齢（和文）' : '年齢',
            value: params?.field_name?.age,
            key: 'age',
            lang: false,
            isShow: true,
        },
        {
            name: '年齢（英文）',
            value: paramsLang?.field_name?.age,
            key: 'age',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? '入場目的（和文）' : '入場目的',
            value: params?.field_name?.admission_purpose,
            key: 'admission_purpose',
            lang: false,
            isShow: true,
        },
        {
            name: '入場目的（英文）',
            value: paramsLang?.field_name?.admission_purpose,
            key: 'admission_purpose',
            lang: true,
            isShow: isLang,
        },
        {
            name: isLang ? 'セミナー受講目的（和文）' : 'セミナー受講目的',
            value: params?.field_name?.purpose_seminar,
            key: 'purpose_seminar',
            lang: false,
            isShow: true,
        },
        {
            name: 'セミナー受講目的（英文）',
            value: paramsLang?.field_name?.purpose_seminar,
            key: 'purpose_seminar',
            lang: true,
            isShow: isLang,
        },
    ],
    button_name: [],
});

CustomItemPersonInfoSiteViewerDefault.defaultProps = {
    params: {},
    paramsLang: {},
    isLang: false,
};

CustomItemPersonInfoSiteViewerDefault.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
    paramsLang: PropTypes.oneOfType([() => null, PropTypes.object]),
    isLang: PropTypes.bool,
};
